import { lazy } from "react";
import Dashboard from "../pages/dashboard/dashboard.js";
import History from "../pages/history/History.js";
import PrivateRoute from "../components/PrivateRouter.jsx";
import PublicRoute from "../components/PublicRouter.jsx";
import UserDetails from "../pages/Userdetails/UserDetails.js";
import LogMessages from "../pages/logMessages/LogMessages.js";
import LogRegistrations from "../pages/logRegistrations/LogRegistrations.js";
import Countries from "../pages/countries/Countries.js";
const Error = lazy(() => import("../components/Error"));
const LoginBoxed = lazy(() => import("../pages/Authentication/LoginBoxed.js"));
const ApiDocs = lazy(() => import("../pages/apiDocs/ApiDocs.js"));

const routes = [
  {
    path: "/history",
    element: (
      <PrivateRoute>
        <History />
      </PrivateRoute>
    ),
  },
  {
    path: "/userdetails",
    element: (
      <PrivateRoute>
        <UserDetails />
      </PrivateRoute>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
  },
  {
    path: "/log-messages",
    element: (
      <PrivateRoute>
        <LogMessages />
      </PrivateRoute>
    ),
  },
  {
    path: "/log-registrations",
    element: (
      <PrivateRoute>
        <LogRegistrations />
      </PrivateRoute>
    ),
  },
  {
    path: "/countries",
    element: (
      <PrivateRoute>
        <Countries />
      </PrivateRoute>
    ),
  },
  {
    path: "/api-docs",
    element: (
      <PrivateRoute>
        <ApiDocs />
      </PrivateRoute>
    ),
  },

  //Authentication
  {
    path: "/login",
    element: (
      <PublicRoute>
        <LoginBoxed />
      </PublicRoute>
    ),
    layout: "blank",
  },

  {
    path: "*",
    element: <Error />,
    layout: "blank",
  },
];

export { routes };
